import { CodebookModel } from 'app/shared/model/shared.model';

export interface FiledLawsuitModel {
  lawsuitFiled: boolean;
  dateOfFilingLawsuit: Date;
  lawsuitSolution: CodebookModel[];
  lawsuitSolutionDate: Date;
  lawsuitSolutionSecondDegree: CodebookModel[];
  lawsuitSolutionSecondDegreeDate: Date;
}

export const filedLawsuitInitialData = {
  lawsuitFiled: false,
  dateOfFilingLawsuit: null,
  lawsuitSolution: null,
  lawsuitSolutionDate: null,
  lawsuitSolutionSecondDegree: null,
  lawsuitSolutionSecondDegreeDate: null,
};
